import React from 'react'
import { useParams } from 'react-router-dom'
import Ddata from '../Data/Ddata'
function Details() {
  let {did}=useParams()
  let dis=Ddata.find((a)=>a.id==did)
  return (
      <div className='pt-5 mt-5 det px-4'>
          <h2>{dis.title}</h2>
        <p className='text-body-tertiary py-3'>{dis.des}</p>
        <img className='w-100 mx-1 mb-5' src={dis.image}/> 
        <p className=' lh-lg text-secondary  fs-5'>{dis.description}</p>
        </div>
  )
}

export default Details
